import axios from 'axios';
import { Estudiantes } from 'generated/graphql';

export interface Estudiante {
	key: string;
	nombre: string;
	apellido: string;
	avatarPath?: string;
}

export const fetchGetEstudianteName = async (estudianteKey: string): Promise<Estudiante> => {
	const isPWA =
		window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone === true;
	const url = `${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/detalle/${estudianteKey}${
		isPWA !== undefined ? `?isPWA=${isPWA}` : ''
	}`;
	const resp = await axios.get(url);
	return resp.data;
};

export const fetchGetProyectosPublicadosEstudiante = async (estudianteKey: string): Promise<Estudiantes> => {
	const resp = await axios.get(`${process.env.REACT_APP_NEST_BACKEND_URL}/estudiante/proyectos/${estudianteKey}`);
	return resp.data;
};
